export default "__VITE_ASSET__BV8qb4mW__"